export default __webpack_public_path__ + "static/media/metapurse.df5e93e4.svg";